/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .factory('ControlService', function ($q) {
            var ControlService = {};

            ControlService.getCheckoutData = function (endpoint, $scope, $element) {
                var deferred = $q.defer();

                $scope.Control.Loading = true;

                $element.get(0).getCheckoutData(endpoint, $element.get(0).data, function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            ControlService.invokeCheckout = function ($scope, $element, method, args) {
                var deferred = $q.defer();

                $scope.Control.Loading = true;

                $element.get(0).invokeCheckout($element.get(0).data, method, args, function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            };

            return ControlService;
        });

})();
             